// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-wrap[data-v-491bf4f2]{width:100vw;height:100vh;background:#262626!important;overflow:hidden;outline:1px solid red}.header-ban[data-v-491bf4f2]{margin:0;padding:0;height:8vh!important;max-height:3.33333vw;overflow:hidden;border-bottom:.10417vw solid #161616;box-shadow:0 .15625vw .3125vw rgba(0,0,0,.03)}.mainbg[data-v-491bf4f2]{margin:0;padding:0;height:97%;background:#161616;min-width:71.14583vw;overflow:auto}", ""]);
// Exports
module.exports = exports;
